import useTranslate from 'modules/local/useTranslate'
import React, {useEffect} from 'react'
import {ZALO_ID} from "../../../envs/_current/config";
import {SiZalo} from "react-icons/si";
import CryptoJS from 'crypto-js';

// Hàm tạo code verifier ngẫu nhiên
function generateCodeVerifier(length = 43) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let codeVerifier = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters?.length);
        codeVerifier += characters[randomIndex];
    }
    return codeVerifier;
}

// Hàm tạo code challenge từ code verifier
function generateCodeChallenge(codeVerifier) {
    // Mã hóa code verifier bằng SHA-256
    const sha256Hash = CryptoJS.SHA256(codeVerifier);

    // Encode Base64 không padding
    const base64Encoded = CryptoJS.enc.Base64.stringify(sha256Hash)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, ''); // Loại bỏ padding

    return base64Encoded;
}

export default function ZaloLoginBtn({
                                         onSuccess, label = 'login with Zalo'
                                     }) {
    const t = useTranslate()

    const handleLogin = () => {
        const scope = 'id,name,picture';
        const codeVerifier = generateCodeVerifier();
        const challenge = generateCodeChallenge(codeVerifier);
        const REDIRECT_URI = window.location.href;
        window.location.href = `https://oauth.zaloapp.com/v4/permission?app_id=${ZALO_ID}&redirect_uri=${REDIRECT_URI}&state=${codeVerifier}&scope=${scope}&code_challenge=${challenge}`;
        // window.location.href = `https://oauth.zaloapp.com/v4/permission?app_id=${ZALO_ID}&redirect_uri=${REDIRECT_URI}&state=${codeVerifier}&scope=${scope}`;
    };

    const handleCallback = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const authorizationCode = urlParams.get('code');
        const codeVerifier = urlParams.get('state');
        if (authorizationCode) {
            onSuccess({
                token: authorizationCode,
                code_verifier: codeVerifier,
                provider: 'zalo'
            })
        }
    };

    useEffect(() => {
        handleCallback().then(r => console.log(r));
    }, []);

    return (
        <div
            onClick={handleLogin}
            style={{
                minHeight: 44, // Chiều cao tối thiểu theo hướng dẫn của Apple
                fontSize: 15, // Kích thước chữ chuẩn của Apple
                fontWeight: '500', // Semibold theo Apple (Tailwind's font-semibold is 600)
                fontFamily: 'SF Pro Text, SF Pro Display, SF Pro Icons, Helvetica Neue, Helvetica, Arial, sans-serif', // Font chữ ưu tiên của Apple
                letterSpacing: '0.03em',
            }}
            className="w-full flex flex-center gap-3 background border border-color-100 rounded-lg hover:shadow hover:scale-2xs cursor-pointer">
            <div className="p-2 border-r border-color-50 flex flex-center">
                <SiZalo size={18}/>
            </div>
            <p className="text-gray-700 leading-none tracking-wide">
                {t(label)}
            </p>
        </div>
    )
}
